<script setup lang="ts">
import { onMounted } from 'vue'

import AppSidebar from '@/components/AppSidebar.vue'
import AppTopbar from '@/components/AppTopbar.vue'
import AppUpdateNotice from '@/components/AppUpdateNotice.vue'
import { useAuth } from '@/stores/auth'
import { useCompanies } from '@/stores/companies'

const auth = useAuth()
const companies = useCompanies()

// Списъкът с дружества е нужен на всеки офисен екран, затова се зарежда веднъж
// тук. Техникът няма избор на дружество — вижда само своите обекти.
onMounted(() => {
  if (!auth.restricted) void companies.load()
})
</script>

<template>
  <div class="shell">
    <AppSidebar />

    <div class="shell__main">
      <AppTopbar />
      <AppUpdateNotice />
      <main class="shell__content">
        <slot />
      </main>
    </div>
  </div>
</template>
